<template>
  <section class="stocks-list-wrapper">
    <div class="stocks-list-filter px-1">
      <form @submit.prevent="filterResults">
        <div class="row align-items-end border rounded py-2 mb-2">
          <div class="col-12 col-sm-6 col-lg-9">
            <label for="stocks-list-verified">Ara</label>
            <fieldset class="form-group mb-0">
              <input class="form-control" id="stocks-list-verified" v-model="search" />
            </fieldset>
          </div>
          <div class="col-12 col-sm-6 col-lg-3 d-flex align-items-center">
            <button type="button" @click="filterResults" class="btn btn-primary btn-block glow stocks-list-clear mt-0">{{  $t('general.filter') }}</button>
            <button type="button" @click="resetFilters" class="btn btn-primary btn-block glow stocks-list-clear mt-0 ml-1">{{  $t('general.clear') }}</button>
          </div>
        </div>
      </form>
    </div>
    <div class="stocks-list-table">
      <div class="card">
        <div class="card-body">
          <!-- datatable start -->
          <div class="table-responsive">
            <data-table
                tableVariant="''"
                :hover="false"
                :outlined="false"
                :striped="false"
                :no-border-collapse="true"
                :borderless="true"
                :bordered="false"
                @onClickDelete="onClickDelete"
                @onClickEdit="onClickEdit"
                :items="formattedItems"
                :fields="fields"
                :per-page.sync="per_page"
                :page.sync="page"
                :paginate="items"
            ></data-table>

          </div>
          <!-- datatable ends -->

          <add-button @onClick="onClickAdd" />

        </div>
      </div>
    </div>
  </section>
</template>
<script>
import DashboardBox from "@/assets/components/DashboardBox";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import DataTable from "@/assets/components/dataTable/DataTable";
import inputFilter from "@/assets/components/filters/InputFilter";
import addButton from "@/assets/components/dataTable/AddButton";
import baseModule, {
  ERROR,
  ITEMS,
  LOADING,
  MODULE_NAME as BASE_MODULE,
  DELETE_ITEM,
  SUCCESS,
  GET_ITEMS
} from "@/core/services/store/stock.module";
import store from "@/core/services/store";

const _BASE_MODULE = BASE_MODULE;

import {
  LARAVEL_DATE_TIME_FORMAT,
  MOMENT_SYSTEM_DATE_FORMAT
} from "@/core/config/constant";
import moment from "moment";

export default {
  name: "MaterialIndex",
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(_BASE_MODULE, baseModule);
  },
  components: {
    DataTable,
    DashboardBox,
    inputFilter,
    addButton
  },
  computed: {
    error() {
      return store.getters[_BASE_MODULE + "/" + ERROR];
    },
    loading() {
      return store.getters[_BASE_MODULE + "/" + LOADING];
    },
    success() {
      return store.getters[_BASE_MODULE + "/" + SUCCESS];
    },
    items() {
      return store.getters[_BASE_MODULE + "/" + ITEMS];
    },
    filters() {
      return {
        per_page: this.per_page,
        page: this.page,
        search: this.search,
        order: this.order,
        sort: this.sort
      };
    },
    formattedItems() {
      let results = [];
      if (
        this.items === null ||
        this.items.data === null ||
        this.items.data === undefined
      )
        return [];

      this.items.data.forEach(item => {
        let createdAt = item.created_at
          ? moment(item.created_at, LARAVEL_DATE_TIME_FORMAT)
          : moment();

        results.push({
          id: item.id,
          name: item.material.name,
          unit_id: item.unit ? item.unit.name : '-',
          stock_code: item.material.stock_code,
          amount: item.amount,
          institution_id: item.branch && item.branch.institution ? item.branch.institution.name : '-',
          branch_id: item.branch ? item.branch.name : '-',
          created_at: createdAt.format(MOMENT_SYSTEM_DATE_FORMAT)
        });
      });

      return results;
    }
  },
  data() {
    return {
      page: 1,
      per_page: 10,
      sort: "id",
      order: "desc",
      search: "",
      fields: [],
      fieldsUser: [
        {
          key: "id",
          label: this.$t("stocks.id"),
          sortable: true,
          class: "text-center border border-top-0 border-right-0 font-size-lg"
        },
        {
          key: "name",
          label: this.$t("stocks.name"),
          sortable: true,
          class: "text-center border border-top-0 border-right-0 font-size-lg"
        },
        {
          key: "stock_code",
          label: this.$t("stocks.stock_code"),
          sortable: true,
          class: "text-center border border-top-0 border-right-0 font-size-lg"
        },
        {
          key: "amount",
          label: this.$t("stocks.amount"),
          sortable: true,
          class: "text-center border border-top-0 border-right-0 font-size-lg"
        },
        {
          key: "unit_id",
          label: this.$t("stocks.unit"),
          sortable: true,
          class: "text-center border border-top-0 border-right-0 font-size-lg"
        }
      ],
      fieldsCustomer: [
        {
          key: "id",
          label: this.$t("stocks.id"),
          sortable: true,
          class: "text-center border border-top-0 border-right-0 font-size-lg"
        },
        {
          key: "institution_id",
          label: this.$t("stocks.institution"),
          sortable: true,
          class: "text-center border border-top-0 border-right-0 font-size-lg"
        },
        {
          key: "branch_id",
          label: this.$t("stocks.branch"),
          sortable: true,
          class: "text-center border border-top-0 border-right-0 font-size-lg"
        },
        {
          key: "name",
          label: this.$t("stocks.name"),
          sortable: true,
          class: "text-center border border-top-0 border-right-0 font-size-lg"
        },
        {
          key: "stock_code",
          label: this.$t("stocks.stock_code"),
          sortable: true,
          class: "text-center border border-top-0 border-right-0 font-size-lg"
        },
        {
          key: "amount",
          label: this.$t("stocks.amount"),
          sortable: true,
          class: "text-center border border-top-0 border-right-0 font-size-lg"
        },
        {
          key: "unit_id",
          label: this.$t("stocks.unit"),
          sortable: true,
          class: "text-center border border-top-0 border-right-0 font-size-lg"
        }
      ]
    };
  },
  methods: {
    filterResults() {
      if (this.loading) {
        return;
      }
      this.$store.dispatch(_BASE_MODULE + '/' + GET_ITEMS, {
          filters: this.filters,
        });
    },
    onClickDelete(id) {
      this.sweetAlertConfirm(
        this.$t("general.are_you_sure"),
        function(self) {
          let payload = {
            id: id
          };
          self.$store.dispatch(_BASE_MODULE + "/" + DELETE_ITEM, payload);
        });
    },
    onClickAdd() {
      this.$router.push({ name: 'store.stocks.create' })
    },
    onClickEdit(id) {
      this.$router.push({ name: "store.stocks.edit", params: { id: id } });
    },
    filterResult() {
      this.$store.dispatch(_BASE_MODULE + "/" + GET_ITEMS, {
        url: this.url,
        filters: this.filters
      });
    },
    resetFilters() {
      this.search = "";
      this.filterResults();
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t("general.dashboard"), route: "dashboard" },
      { title: this.$t("stocks.self") }
    ]);

    this.fields = this.fieldsUser;
    if (this.isCustomer) {
      this.fields = this.fieldsCustomer;
    }

    this.filterResults();
  },
  watch: {
    sort() {
      this.filterResults();
    },
    order() {
      this.filterResults();
    },
    per_page() {
      this.filterResults();
    }
  }
};
</script>

<style>
.filter-card {
  background: white;
  border-radius: 25px !important;
  padding: 20px;
}
</style>
